var React = require('react');

function IconCalendar (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M23.6 3.182h-1.2V1H20v2.182H8V1H5.6v2.182H4.4A2.306 2.306 0 0 0 2 5.364v17.454A2.306 2.306 0 0 0 4.4 25h19.2a2.306 2.306 0 0 0 2.4-2.182V5.364a2.306 2.306 0 0 0-2.4-2.182zm0 19.636H4.4v-12h19.2zm0-14.182H4.4V5.364h19.2z","transform":"translate(-2 -1)"}));
}

IconCalendar.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconCalendar;

IconCalendar.default = IconCalendar;
